<template>
  <ul class="list-unstyled default-data-header mb-0">
    <li
      v-for="(item, index) in items"
      class="default-data-header__item"
      :key="index"
    >
      <span
        v-if="item.data.length"
        class="default-data-header__item-content">
        <strong>
          {{ item.title }}:
        </strong>
        <list-aggregator
          modal-item-name-key="name"
          :modal-title="modalTitle"
          :modal-table-items="item.data || []"
          :modal-table-header="item.title"
        />
      </span>
    </li>
  </ul>
</template>

<script>
import DefaultDataHeaderMixin from '@/components/header/mixin/defaultDataHeaderMixin';
import ListAggregator from '@/components/listAggregator';

export default {
  components: { ListAggregator },
  mixins: [DefaultDataHeaderMixin],
};
</script>

<style lang="sass" scoped>
@import "src/styles/defaults/mobile-first"
.default-data-header
  display: flex
  flex-wrap: wrap
  +media-max-sm()
    justify-content: center
  &__item
    display: inline-block

  &__item-content > strong,
  ::v-deep .list-aggregator
    color: var(--color-black-87)

  &__item-content
    margin-right: .5rem
    margin-bottom: .2rem
    display: flex
    font-size: .85rem
    padding: 5px 10px
    background-color: var(--color-border-inner)
    border-radius: 50px
    white-space: nowrap
    ::v-deep .col-auto
      margin-left: .4rem
      padding: 0
</style>
